'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var CheckboxListItem = require('../CheckboxListItem/CheckboxListItem.js');

const CheckboxListContainer = ({ children, className, testId })=>{
    return jsxRuntime.jsx("div", {
        className: tailwindMerge.twMerge('flex w-full flex-col gap-3', className),
        "data-testid": testId,
        children: children
    });
};
/**
 * 체크박스 아이템들을 목록 형태로 표시하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array} props.data - 체크박스 아이템 데이터 배열 ({label, checked, onChange}[])
 * @param {string} [props.className] - 리스트 컨테이너에 적용할 스타일 클래스이름
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {'box' | 'circle'} [props.type='box'] - 체크박스 스타일 타입
 *
 * @example
 * const items = [
 *   { label: '항목 1', checked: false, onChange: () => {} },
 *   { label: '항목 2', checked: true, onChange: () => {} }
 * ];
 *
 * return (
 *   <CheckboxList
 *     data={items}
 *     type="box"
 *     className="my-4"
 *     testId="checkbox-list"
 *   />
 * );
 */ const CheckboxList = ({ data, className, testId, type = 'box' })=>{
    return jsxRuntime.jsx(CheckboxListContainer, {
        className: className,
        testId: testId,
        children: data.map((item, index)=>jsxRuntime.jsx(CheckboxListItem, Object.assign({}, item, {
                type: type
            }), index))
    });
};

module.exports = CheckboxList;
